import { Button, Checkbox, Col, DatePicker, Form, Input, InputNumber, Pagination, Radio, Row, Select, Space, Table, Tabs } from 'antd';
import React, { useState } from 'react';
import { Link, useLoaderData, useNavigate } from 'react-router-dom';
import EventEmitter from '../../utils/eventEmitter';

const columns = [
  {
    title: 'Name',
    dataIndex: 'name',
    key: 'name',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white',
    width: '20%'
  },
  {
    title: 'Contact',
    dataIndex: 'contact',
    key: 'contact',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white',
    width: '20%'
  },
  {
    title: 'Email',
    dataIndex: 'email',
    key: 'email',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white',
    width: '20%'
  },
  {
    title: 'Phone',
    dataIndex: 'phone',
    key: 'phone',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white',
    width: '20%'
  },
  {
    title: 'Action',
    key: 'operation',
    width: '20%',
    // fixed: 'right',
    className: 'whitespace-nowrap font-medium text-dark-600 dark:text-white',
    render: (_, record) => (
      <Link className='h-full w-full' to={'/sales/customers/'+record.seo}>
        EDIT
      </Link>
    )
  }
]




const Customers = () => {
  const customers = useLoaderData();
  const navigate = useNavigate();

  const onRow = (record, rowIndex) => {
    return {
      onClick: () => EventEmitter.dispatch('posordercontactselected', {id: record.id, cus_name: record.name})
    };
  }
  return (
    <div>
      <div className='flex justify-between mx-4'>
        
      </div>
      <Table
        key={'name'}
        onRow={onRow}
        rowClassName={'hover:cursor-pointer'}
        dataSource={customers}
        columns={columns}
        // scroll={{ x: 1500 }}
        pagination={false}
      />
    
    </div>
  )
}

export default Customers;